import React from 'react';
import { HeroVariant12 } from '../components/HeroVariant12';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage12() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1465">
      <Navigation data-id="element-1466" />
      <main data-id="element-1467">
        <HeroVariant12 data-id="element-1468" />
        <WhyUs data-id="element-1469" />
        <Services data-id="element-1470" />
        <FAQ data-id="element-1471" />
        <Testimonials data-id="element-1472" />
        <Consultation data-id="element-1473" />
      </main>
      <Footer data-id="element-1474" />
      <CookieBanner data-id="element-1475" />
      <FloatingContact data-id="element-1476" />
    </div>;
}